import { Button } from "@findemdev/maui";
import styled, { css } from "styled-components";

export const CredBuilderContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors['white']};
`;

export const Heading = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.dimensions.spacing[4]} ${theme.dimensions.spacing[5]}`};
  border-bottom: 1px solid ${({ theme }) => theme.colors['grey-300']};

  p {
    color: ${({ theme }) => theme.colors['grey-500']};
    font-size: 14px;
    margin-bottom: 0px;
  }
`

export const NewCredentialButton = styled(Button)`
  margin-top: ${({ theme }) => theme.dimensions.spacing[2]};
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

export const GridContainer = styled.div<{
  $addGrid: boolean
}>`
  ${({ $addGrid }) => $addGrid && css`
    align-items: stretch;
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  `};
`;

export const ContentArea = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors['grey-300']};
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
`;

export const TitleSectionWrapper = styled.div`
  margin: ${({ theme }) => `${theme.dimensions.spacing[3]} ${theme.dimensions.spacing[5]} 0px ${theme.dimensions.spacing[5]}`};
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;

  .credential-user-select--impersonating.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${({ theme }) => theme.colors['blue-100']};
    border-color: ${({ theme }) => theme.colors['blue-200']};
  }
`;

export const MyCredentialTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => theme.dimensions.spacing['1']};
`;

export const TabItem = styled.button<{ $selected: boolean }>`
  height: 25px;
  color: ${({ theme: { colors }, $selected }) => $selected ? colors.black : colors['grey-600']};
  padding: 4px 8px 4px 8px;
  border: none;
  border-radius: ${({ theme }) => `${theme.dimensions['border-radius'].sm}`};
  background-color: ${({ theme: { colors }, $selected }) => $selected ? colors.white : colors['grey-200']};
  cursor: pointer;
  box-shadow: ${({ $selected }) => $selected ? "0px 1px 2px 0px #1018280D" : ""};
`;
export const TabsContainer = styled.div`
  height: 28px;
  background-color: ${({ theme: { colors } }) => colors['grey-200']};
  border-radius: ${({ theme }) => `${theme.dimensions['border-radius'].sm}`};
  display: flex;
  align-items: center;
  padding: 4px 2px;
`;

export const FavoriteColumnWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${({ theme }) => theme.dimensions['spacing'][1]};
`;

export const FavoriteButton = styled.button`
  all: unset;
  cursor: pointer;
`;

export const FavoriteButtonWrapper = styled.div`
  margin-right: 2px;
  gap: 4px;
  justify-content: flex-end;
  align-items: center;
  margin-top: 6px;
`;
